import classNames from 'classnames';
import React from 'react';
import DropdownSelector from '../actions/DropdownSelector';
import MenuDotsHorizontal from '../icons/MenuDotsHorizontal';

export type MenuOption = {
  id: string;
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
};

type MenuProps = {
  options: MenuOption[];
  icon?: React.ReactNode;
  position?: 'left' | 'right';
  className?: string;
  buttonClassName?: string;
};

const Menu: React.FC<MenuProps> = ({
  options,
  icon,
  position = 'left',
  className,
  buttonClassName,
}) => {
  // Prepare options for DropdownSelector - it expects a list of values
  const menuValues = options.map(opt => opt.id);

  // Custom render function for dropdown items
  const renderMenuOption = (id: string) => {
    const option = options.find(opt => opt.id === id);
    if (!option) return id;

    return (
      <div className="flex items-center">
        {/* {option.icon && (
          <div className="mr-2 flex items-center">{option.icon}</div>
        )} */}
        <span>{option.label}</span>
      </div>
    );
  };

  return (
    <DropdownSelector
      className={className}
      DropAlignLeft={position === 'left'}
      DropAlignRight={position === 'right'}
      vertical
      buttonTransparent
      iconDropMenu={MenuDotsHorizontal}
      icon={icon}
      iconClass={classNames('!p-0.5')}
      values={menuValues}
      renderValue={renderMenuOption}
      onChange={id => {
        const option = options.find(opt => opt.id === id);
        if (option) {
          option.onClick();
        }
      }}
    />
  );
};

export default Menu;
